module.exports = __webpack_public_path__ + "static/media/symptomsicon_nausea_uni.3c162b93.svg";